import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TextField, FormControl, FormHelperText } from '@material-ui/core';
import PlacesAutocomplete from 'react-places-autocomplete';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

const propTypes = {
  classes: PropTypes.shape({
    searchFormRoot: PropTypes.string,
    suggestionWrapper: PropTypes.string,
    suggestionsContainer: PropTypes.string,
    suggestionLoading: PropTypes.string,
    suggestionItem: PropTypes.string,
    suggestionItemActive: PropTypes.string,
    searchTextField: PropTypes.string,
  }).isRequired,
  id: PropTypes.string.isRequired,
  input: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  handleLocationChange: PropTypes.func.isRequired,
};

const PostcodeSearchField = props => {
  const [suggestionsOpen, setSuggestionsOpen] = useState(false);
  const {
    classes: {
      searchFormRoot,
      suggestionsContainer,
      suggestionWrapper,
      suggestionItem,
      suggestionLoading,
      suggestionItemActive,
      searchTextField,
      errorText,
      locationRoot,
    },
    id,
    input,
    label,
    meta: { error, invalid },
    handleLocationChange,
  } = props;

  let {
    meta: { touched },
  } = props;

  const handleSelect = address => {
    // When user picks a result, fill in the text field
    input.onChange(address);
  };

  const handleBlur = () => {
    setSuggestionsOpen(false);
    input.onBlur();
  };

  const handleFocus = () => {
    setSuggestionsOpen(true);
    touched = true;

    // Tell the parent component that we have a new value (so bypass lat and long ==> postcode conversion)
    handleLocationChange();
  };

  return (
    <FormControl className={locationRoot}>
      <PlacesAutocomplete
        native
        {...input}
        inputProps={{
          name: label,
          id,
        }}
        value={input.value}
        onChange={input.onChange}
        onSelect={handleSelect}
        searchOptions={{
          componentRestrictions: { country: 'au' },
          types: ['(regions)'],
        }}
        highlightFirstSuggestion
        error={touched && invalid}
        placeholder="Suburb of Job"
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className={searchFormRoot}>
            <TextField
              label={label}
              id={id}
              {...getInputProps({})}
              placeholder="Suburb of Job"
              className={searchTextField}
              onFocus={handleFocus}
              onBlur={handleBlur}
              // error={touched && invalid}
            />
            {touched && error && (
              <FormHelperText id={`${id}-helper-text`} className={errorText}>
                {error}
              </FormHelperText>
            )}
            <div className={suggestionWrapper}>
              {suggestionsOpen && (
                <div className={suggestionsContainer}>
                  {loading && (
                    <div className={suggestionLoading}>
                      Loading... <CircularProgress />
                    </div>
                  )}
                  {!loading &&
                    suggestions.map(suggestion => {
                      const className = suggestion.active
                        ? classNames(suggestionItem, suggestionItemActive)
                        : suggestionItem;

                      return (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            className,
                          })}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    </FormControl>
  );
};

PostcodeSearchField.propTypes = propTypes;

export default withStyles(styles)(PostcodeSearchField);
